if (!customElements.get('product-urgency')) {
  customElements.define(
    'product-urgency',
    class ProductUrgency extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        if (typeof subscribe !== 'function') return;

        // Dawn re-fetches the section on every variant change and passes the parsed
        // document in the event. Swap in the freshly rendered urgency (or clear it when
        // the new variant is out of stock / above the threshold) — no extra request.
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data?.sectionId !== this.sectionId) return;
          const updatedUrgency = event.data.html?.getElementById(this.id);
          this.innerHTML = updatedUrgency ? updatedUrgency.innerHTML : '';
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }
    }
  );
}
